import type { ThemeConfig } from 'antd'

/**
 * Ant Design theme token configuration.
 * Primary color is synchronized with Tailwind CSS theme.extend.colors.primary.
 */
const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: '#1677ff',
  },
  components: {
    Menu: {
      // 子菜单背景与一级菜单保持一致（默认子菜单背景为浅灰色）
      subMenuItemBg: '#ffffff',
    },
    Table: {
      // 收紧单元格垂直内边距，降低行高（默认 middle 16 / small 8）
      cellPaddingBlock: 8,
      cellPaddingBlockSM: 5,
    },
  },
}

export default themeConfig
